import React from 'react';

const Header = ({ children, canBeClosed, onCancelClick }) => (
    <div className="modal-header">
        <div>{children}</div>
        {canBeClosed ? <div className="close" onClick={onCancelClick} /> : null}
    </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Modal/Header.jsx